import { Link } from "react-router-dom";
import { SECURITY_POLICY_FULL_TEXT, SECURITY_POLICY_PAGE_TITLE } from "../utils/cookies";
import "./SecurityPolicy.scss";

export const SecurityPolicy = () => {
  return (
    <div className="security-policy-page">
      <div className="security-policy-container">
        <Link to="/" className="security-policy-back">
          ← На главную
        </Link>
        <h1 className="security-policy-title">{SECURITY_POLICY_PAGE_TITLE}</h1>
        <div className="security-policy-body">{SECURITY_POLICY_FULL_TEXT}</div>
      </div>
    </div>
  );
};
